module.exports = __webpack_public_path__ + "img/ajax2.6b9cfb5d.jpg";